var _path, _path2, _g, _path3, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrtLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 35,
    viewBox: "0 0 73 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_635)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2354 23.4098C44.804 23.4098 44.1404 23.3803 43.5652 23.2676V16.4864C44.1127 16.2304 44.8328 16.0872 45.6966 16.0872C47.7992 16.0872 49.2106 17.3701 49.2106 19.62C49.2106 22.0415 47.6842 23.4098 45.2354 23.4098ZM45.9842 13.0695C45.0916 13.0695 44.1404 13.1811 43.5641 13.4676V7.59637H40.1077V25.745C41.6352 26.1442 43.6228 26.3422 45.3515 26.3422C49.7868 26.3422 52.7267 24.007 52.7267 19.7337C52.7267 15.689 49.9892 13.0695 45.9842 13.0695ZM59.6861 12.9732C56.3004 12.9732 54.1093 14.2147 54.1093 18.0548V26.1376H57.6421V18.2845C57.6421 16.8407 58.4307 16.0915 59.9482 16.0915C60.7955 16.0915 61.6715 16.202 62.4015 16.4328V13.204C61.5044 13.0575 60.5964 12.9798 59.6861 12.9732Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_635",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 8,
    width: 9,
    height: 19
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.015 8.59418H72.1988V26.4486H64.015V8.59418Z",
    fill: "#414042"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_635)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.7787 23.3707C68.28 23.3707 67.5024 22.6292 67.5024 21.2051V16.1815H72.0505V13.3334H67.5024V8.59418H64.015V21.4337C64.015 25.2225 66.1763 26.4486 69.5199 26.4486C70.3538 26.4486 71.2763 26.3665 72.1988 26.2211V23.0339C71.4798 23.2614 70.6149 23.3696 69.7787 23.3696",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2_635",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 31,
    height: 35
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1829 0C14.9838 0 14.7836 0.0415625 14.6321 0.124688L0.767606 7.59609L16.2989 16.5375C16.4427 16.6141 16.5533 16.8 16.5533 16.9662L16.5522 30.0092C16.5522 30.1733 16.4339 30.3614 16.289 30.438L15.4528 30.8973C15.3831 30.9334 15.2957 30.952 15.2028 30.952H15.1862C15.0867 30.9553 14.9927 30.9356 14.9208 30.8973L14.0813 30.438C13.9386 30.3625 13.8224 30.1733 13.8224 30.0092V18.3827C13.8147 18.2973 13.7517 18.1934 13.6831 18.1541L0 10.278V25.7053C0 26.0509 0.245545 26.4764 0.5475 26.6514L14.6398 34.8698C14.7891 34.9562 14.9849 35 15.1818 35H15.1873C15.3864 35 15.5855 34.9584 15.7348 34.8698L29.8294 26.6514C30.1302 26.4753 30.3757 26.0509 30.3746 25.7053V10.278L21.1014 15.6198C20.9576 15.703 20.7342 15.6964 20.5949 15.6111L19.773 15.1277C19.7067 15.0872 19.6447 15.0216 19.5983 14.9417L19.5894 14.9286C19.5375 14.8444 19.5076 14.7536 19.5043 14.6727L19.4833 13.7255C19.4777 13.5658 19.5839 13.3711 19.7266 13.288L29.607 7.59609L15.7437 0.124688C15.591 0.0404688 15.3897 0 15.1884 0H15.1829Z",
    fill: "url(#paint0_linear_2_635)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2_635)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1829 0C14.9838 0 14.7836 0.0415625 14.6321 0.124688L0.767606 7.59609L16.2989 16.5375C16.4427 16.6141 16.5533 16.8 16.5533 16.9662L16.5522 30.0092C16.5522 30.1733 16.4339 30.3614 16.289 30.438L15.4528 30.8973C15.3831 30.9334 15.2957 30.952 15.2028 30.952H15.1862C15.0867 30.9553 14.9927 30.9356 14.9208 30.8973L14.0813 30.438C13.9386 30.3625 13.8224 30.1733 13.8224 30.0092V18.3827C13.8147 18.2973 13.7517 18.1934 13.6831 18.1541L0 10.278V25.7053C0 26.0509 0.245545 26.4764 0.5475 26.6514L14.6398 34.8698C14.7891 34.9562 14.9849 35 15.1818 35H15.1873C15.3864 35 15.5855 34.9584 15.7348 34.8698L29.8294 26.6514C30.1302 26.4753 30.3757 26.0509 30.3746 25.7053V10.278L21.1014 15.6198C20.9576 15.703 20.7342 15.6964 20.5949 15.6111L19.773 15.1277C19.7067 15.0872 19.6447 15.0216 19.5983 14.9417L19.5894 14.9286C19.5375 14.8444 19.5076 14.7536 19.5043 14.6727L19.4833 13.7255C19.4777 13.5658 19.5839 13.3711 19.7266 13.288L29.607 7.59609L15.7437 0.124688C15.591 0.0404688 15.3897 0 15.1884 0H15.1829Z",
    fill: "#FF0000"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_635",
    x1: 410.999,
    y1: 2970.31,
    x2: 1699.11,
    y2: 1877.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A80034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB0031"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_635"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrtLogo);
export default __webpack_public_path__ + "static/media/brt-logo.ce45a54336a4a1dc0484431f606271e7.svg";
export { ForwardRef as ReactComponent };